"use strict"

import React, { useEffect, useState } from "react"
import memoize from "memoize-one"
import deepEqual from "deep-equal"
import { Button } from "react-bootstrap"

import ObservationSelectorPopper from "../../widgets/ObservationSelectorPopper"
import {
  makePlotList as plotListMethod,
  getFormattedMessage,
} from "../../../../../components/shared_components_registration"

export const ObsVsObsEditor = ({
  plotConfigUpdater,
  queryTags,
  observationTypesArray,
  siteReactors = [],
  availableOnly,
}) => {
  const [xTag, setXTag] = useState(null)
  const [yTag, setYTag] = useState(null)

  useEffect(() => {
    if (xTag && yTag) {
      plotConfigUpdater({
        title: `${xTag.label || xTag.tag} vs ${yTag.label || yTag.tag}`,
        special: "obs-vs-obs",
        observations: [xTag, yTag],
      })
    }
  }, [xTag, yTag])

  const chooseTag = (key, sel, updValue) => {
    if (
      (key === "xTag" && (!yTag || (yTag && yTag.tag !== sel.observations[0].tag))) ||
      (key === "yTag" && (!xTag || (xTag && xTag.tag !== sel.observations[0].tag)))
    ) {
      updValue(sel.observations[0])
    }
  }

  const makePlotList = memoize(plotListMethod, deepEqual)

  const loadedObservationTypes = observationTypesArray.filter((ota) => ota !== undefined)

  const plotList = queryTags
    ? makePlotList(
        [], // No special plots here
        queryTags,
        [], // No graphs to filter out
        loadedObservationTypes,
      ).filter((p) => (availableOnly ? !p.notAvailable : p))
    : []

  const obsChooserButton = (key, metric, updValue) => {
    const tagData = metric || {}
    return (
      <ObservationSelectorPopper
        options={plotList}
        nameFn={(plot) => plot.title}
        onSelect={(sel) => chooseTag(key, Object.assign({}, sel), updValue)}
        runFilters={siteReactors}
      >
        <Button variant={"outline-primary"} className={"btn-sm"}>
          {tagData.label || tagData.tag || getFormattedMessage("general.select", "Select")}
        </Button>
      </ObservationSelectorPopper>
    )
  }

  return (
    <div style={{ marginBottom: "15px" }}>
      <div style={{ marginBottom: "7px" }}>
        {getFormattedMessage("graphing.select.tags.to.compare", "Select Tags To Compare")}:
      </div>
      <div style={{ display: "flex" }}>
        <div>
          {getFormattedMessage("graphing.x.axis", "X-Axis")}:&nbsp;
          {obsChooserButton("xTag", xTag, setXTag)}
        </div>
        &nbsp;
        <div>
          {getFormattedMessage("graphing.y.axis", "Y-Axis")}:&nbsp;
          {obsChooserButton("yTag", yTag, setYTag)}
        </div>
      </div>
    </div>
  )
}
